import { styled } from "@mui/material";
import Grid from '@mui/material/Grid2';

import CardList from "./DeviceCardList";
export const DeviceCardList = CardList;
import FilterBar from "./DeviceFilterBar";
export const DeviceFilterBar = FilterBar;

export const Frame = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderTopLeftRadius: theme.shape.borderRadius,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  height: "100%",
  width: "100%",
}));
